import React from "react";

//Navbar -> photos import
export const NavbarImageStatic = '/assets/navbar/NavbarImageStatic.png';
export const NavbarImageWhenScrolled = '/assets/navbar/NavbarImageWhenScrolled.png';

//Footer -> photos import
export const FooterImage = '/assets/footer/FooterImage.png';

//Home page god photo -> photos import
export const GodPhoto = '/assets/homePage/mdlogo.png';

//AboutUs page -> photos import
export const AboutPageImageBg = '/assets/aboutUsPage/AboutImageBg.png';
export const AboutAmbAnimated = '/assets/aboutUsPage/AboutAmbAnimated.png';



//Services page -> ambulance photos import
export const photos = [
  '/assets/servicesPage/ambulanceImages/ambulance1.webp',
  '/assets/servicesPage/ambulanceImages/ambulance2.webp',
  '/assets/servicesPage/ambulanceImages/ambulance3.webp',
  '/assets/servicesPage/ambulanceImages/ambulance4.webp',
  '/assets/servicesPage/ambulanceImages/ambulance5.webp',
];

//Services page -> HeroSection photo import
export const servicesHeroPhoto = '/assets/servicesPage/HeroTeamImage.png';